import References from 'features/references';
import { useTitle } from '../helpers';

/**
 * @page References
 */
const ReferencesPage = () => {
  useTitle('Справки');

  return (
    <div>
      <h3>Справки</h3>
      <References />
    </div>
  );
};

export default ReferencesPage;
